import { ReactNode } from 'react';

export enum SlotVariants {
  success = 'success',
  warning = 'warning',
  danger = 'danger',
  info = 'info',
  blackout = 'blackout',
  default = 'default',
  blackoutLocation = 'blackout-location',
}

export interface ISlotProps {
  details: ReactNode;
  shortDetails?: ReactNode;
  variant?: `${SlotVariants}`;
  handleClick?: () => void;
  blackoutLocation?: any;
  eventTypes?: TEventTypes[] | [];
  eventName?: string;
}

export type TEventTypes = {
  type: string;
  amount: number;
};
